var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.163 2.819C9 3.139 9 3.559 9 4.4V11H7.803C6.92 11 6.478 11 6.269 11.176C6.17932 11.2514 6.10854 11.3467 6.06235 11.4544C6.01616 11.5621 5.99583 11.6791 6.003 11.796C6.02 12.07 6.325 12.389 6.934 13.028L11.132 17.429C11.434 17.747 11.585 17.905 11.762 17.964C11.9164 18.0158 12.0836 18.0158 12.238 17.964C12.415 17.905 12.566 17.747 12.868 17.429L17.066 13.029C17.676 12.389 17.98 12.069 17.996 11.796C18.0033 11.6791 17.9831 11.5622 17.9371 11.4545C17.8911 11.3469 17.8205 11.2515 17.731 11.176C17.522 11 17.081 11 16.197 11H15V4.4C15 3.56 15 3.14 14.836 2.819C14.6924 2.53666 14.4631 2.30702 14.181 2.163C13.861 2 13.441 2 12.6 2H11.4C10.56 2 10.14 2 9.819 2.163C9.53651 2.30685 9.30685 2.53651 9.163 2.819ZM5 21C5 21.2652 5.10536 21.5196 5.29289 21.7071C5.48043 21.8946 5.73478 22 6 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21C19 20.7348 18.8946 20.4804 18.7071 20.2929C18.5196 20.1054 18.2652 20 18 20H6C5.73478 20 5.48043 20.1054 5.29289 20.2929C5.10536 20.4804 5 20.7348 5 21Z",
    fill: "#FA8316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.21355dabc8472bb9fd36ad0aec20e4ec.svg";
export { ForwardRef as ReactComponent };